import { render } from "./DownloadDocument.vue?vue&type=template&id=8c85ec3e&scoped=true"
import script from "./DownloadDocument.vue?vue&type=script&lang=js"
export * from "./DownloadDocument.vue?vue&type=script&lang=js"

import "./DownloadDocument.vue?vue&type=style&index=0&id=8c85ec3e&lang=sass&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c85ec3e"]])

export default __exports__